import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";

const FAQS = [
  ["Can I print double-sided?", "Yes. Choose single or double-sided for both black & white and colour jobs — double-sided saves paper and halves the weight of big reports."],
  ["How many sheets can a bound document hold?", "It depends on the finishing. Stapled documents hold up to about 40 sheets, while spiral and wiro binding hold up to about 125 sheets."],
  ["Which file formats do you accept?", "PDF, DOCX and PPTX are all fine. PDF is preferred — it prints exactly as designed and speeds up the job."],
  ["What paper do you use?", "Clean 70 GSM white stock as standard, with 100–300 GSM options for covers, photos and premium presentations."],
  ["Do you deliver across Mumbai?", "Yes — doorstep delivery across the city, plus store pickup if you are nearby. Quick dispatch on all confirmed jobs."],
  ["Do you provide GST invoices for bulk orders?", "Yes. Corporate and institutional bulk orders come with proper GST invoicing."],
];

export default function Faq() {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-surface/40 border-y border-edge" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Reveal className="mb-12 text-center">
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyanbrand">
            / FAQ
          </span>
          <h2 className="mt-4 font-display font-semibold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-paper">
            Asked every day.
          </h2>
        </Reveal>

        <Reveal delay={1}>
          <Accordion type="single" collapsible className="w-full border-t border-edge">
            {FAQS.map(([q, a], i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-edge" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display font-medium text-lg text-paper hover:text-cyanbrand hover:no-underline py-6 [&[data-state=open]>svg]:text-cyanbrand">
                  {q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-mist leading-relaxed">
                  {a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
